import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { IAction, IFees } from '../merchant-interfaces';
import { feeDataTypes, feesList, getFormattedFeeList } from '../merchant-context-variables';
import { merchantActionTypes } from '../action-types';
import { toaster } from 'rsuite';
import toastMessage from '../../../components/ToastMessage';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import * as React from 'react';
import { IFeeData } from '../../../components/merchants/FeeTableRow';
import { GET, PUT } from '../../store-helper';

export const fetchFees = async (
	dispatch: React.Dispatch<IAction>,
	activeFee: IFeeData,
	nonStandardFee: IFeeData
): Promise<void> => {
	try {

		const data = await GET({ pathname: `${BASE_URL.MERCHANTS}/Config` });

		const defaultFees: IFees[] = feesList(data);

		const standardFees = {
			...activeFee
		};

		const allFormattedFees = getFormattedFeeList(data);

		(data || [])?.forEach(el => {
			switch (el?.name) {
				case feeDataTypes.PERCENTAGE:
					standardFees.percentage = el?.amount / 100;
					standardFees.percentageId = el?.id;
					standardFees.minFeeAmount = el?.minimumFeeAmount ? el?.minimumFeeAmount / 100 : null;
					break;
				case feeDataTypes.FEE_AMOUNT:
					standardFees.feeAmount = el?.amount / 100;
					standardFees.feeAmountId = el?.id;
					break;
				case feeDataTypes.CHARGEBACK:
					standardFees.chargeback = el?.amount / 100;
					standardFees.chargebackId = el?.id;
					break;
				case feeDataTypes.REFUND_FEE:
					standardFees.refundFee = el?.amount / 100;
					standardFees.refundFeeId = el?.id;
					break;
				case feeDataTypes.RISK_FEE:
					standardFees.riskFee = el?.amount / 100;
					standardFees.riskFeeId = el?.id;
					break;
			}
		});

		dispatch({ type: merchantActionTypes.SET_DEFAULT_FEE, payload: defaultFees });
		dispatch({ type: merchantActionTypes.SET_ALL_DEFAULT_FEE, payload: allFormattedFees });
		dispatch({ type: merchantActionTypes.FETCH_STANDARD_FEES, payload: standardFees });
		dispatch({ type: merchantActionTypes.FETCH_FEE, payload: [standardFees, nonStandardFee] });

	} catch (e) {
		console.log(e);
		sendSentryMessage({ name: `GET Fetch config (fees) error`, context: e });
		dispatch({ type: merchantActionTypes.FETCH_FAIL });
	}
};

export const setFeesData = (dispatch: React.Dispatch<IAction>, data: IFees[]): void => {
	dispatch({ type: merchantActionTypes.SET_MERCHANT_FEES, payload: data });
};

export const setDefaultFees = (dispatch: React.Dispatch<IAction>, data: IFees[]): void => {
	dispatch({ type: merchantActionTypes.SET_ALL_DEFAULT_FEE, payload: data });
};

export const setFeesConfig = async (params: { amount: number; id: string }[]): Promise<void> => {
	try {
		// await axios.put(`${BASE_URL.MERCHANTS}/Config/fees`, params);
		await PUT({
			pathname: `${BASE_URL.MERCHANTS}/Config/fees`,
			body: params
		});
		toaster.push(toastMessage({
			text: 'Fees configurations were saved!',
			type: 'success'
		}), { placement: 'topEnd' });
	} catch (e) {
		sendSentryMessage({ name: `PUT Set fees error`, context: e });
		console.log('e', e);
	}
};
